<template>
    <div class="qrcode_modal_box">
        <b-modal ref="modal" id="class_qrcode_modal" hide-footer centered>
            <div class="qrcode_content">
                <h4 class="text-center">課程QR CODE</h4>
                <div class="text-center">
                    <qriously :value="pageUrl" :size="245" style="margin-bottom: 30px;" />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            pageUrl: {
                type: String,
                required: true,
            }
        },
    }
</script>
